import FindALawyerSearchBlock from './FindALawyerSearchBlock';

export default FindALawyerSearchBlock;
